var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PartnerHeader',{attrs:{"img_header":_vm.header_image,"header":"จัดโปรโมชั่นแถมราคาถูกสุด","link_back":"promotioninformation"}}),_c('MenuPartner'),_c('Promotion_add_pos_free')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }